module.exports = __webpack_public_path__ + "img/cpgz.ccbfac46.png";